import React from 'react';

interface ActivityHeartbeatIconProps {
  size?: number;
  color?: string;
}

/**
 * ActivityHeartbeatIcon Component
 * @description A heartbeat/activity line icon for monitoring status
 */
export const ActivityHeartbeatIcon: React.FC<ActivityHeartbeatIconProps> = ({ 
  size = 32, 
  color = '#009951' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 32 32"
    >
      <path 
        fill={color} 
        d="M25.012 3a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4h-18a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zM18.12 8.003a.81.81 0 0 0-.727.635l-2.55 11.496-2.37-8.298a.814.814 0 0 0-1.108-.52.8.8 0 0 0-.348.292l-3.004 4.515h-1.19a.811.811 0 0 0 0 1.624h1.624a.81.81 0 0 0 .676-.362l2.274-3.41 2.76 9.677a.813.813 0 0 0 1.573-.047l2.68-12.048 2.273 5.683a.81.81 0 0 0 .753.51h3.248a.812.812 0 0 0 0-1.624h-2.696l-3.037-7.615-.01.002a.81.81 0 0 0-.82-.51"
      />
    </svg>
  );
};

export default ActivityHeartbeatIcon;

